export default __webpack_public_path__ + "static/media/php.46a64da1.png";